import CopyBox from '@/components/CopyBox'
import api from '@/utils/api'
import { firestore } from '@/utils/firebase'
import { ActionIcon, Anchor, Box, Breadcrumbs, Button, Modal, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { doc, getDoc } from 'firebase/firestore'
import { useRouter } from 'next/router'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import { BrandLinkedin, BrandTwitter, Heart, Share as ShareIcon } from 'tabler-icons-react'
import { BlogMetadata } from '../../../types/global'

const Like = () => {
    const router = useRouter()
    const [likes, setLikes] = useState(0)
    const [liked, setLiked] = useState(false)

    useEffect(() => {
        const slug = router.query.slug as string
        const likedPosts = JSON.parse(window.localStorage.getItem("likedPosts") || "[]") as Array<string>
        if (likedPosts.includes(slug)) {
            setLiked(true)
        }
    }, [])

    useEffect(() => {
        const slug = router.query.slug as string
        if (!slug) return;
        getDoc(doc(firestore, "blogs", slug)).then((snap) => {
            const blogData = snap.data() as BlogMetadata
            console.log(blogData)
            setLikes(blogData?.likes || 0)
        })
    }, [])

    return <div className='flex fdc aic'>
        <ActionIcon radius={100} size="lg" color={liked ? "red" : undefined} onClick={() => {
            if (!liked) {
                const slug = router.query.slug as string
                setLiked(true)
                setLikes((l) => l + 1)
                api.post("/public/blog/like", {
                    slug
                }).then((res) => {
                    if (res.error) {
                        setLiked(false)
                        return setLikes((l) => l - 1)
                    }
                    const likedPosts: Array<string> = JSON.parse(window.localStorage.getItem("likedPosts") || "[]")
                    likedPosts.push(slug)
                    window.localStorage.setItem("likedPosts", JSON.stringify(likedPosts))
                })
            } else {
                const slug = router.query.slug as string
                setLiked(false)
                setLikes((l) => l - 1)
                api.post("/public/blog/unlike", {
                    slug
                }).then((res) => {
                    if (res.error) {
                        setLiked(true)
                        return setLikes((l) => l + 1)
                    }
                    const likedPosts: Array<string> = JSON.parse(window.localStorage.getItem("likedPosts") || "[]")
                    const idx = likedPosts.indexOf(slug)
                    likedPosts.splice(idx, 1)
                    window.localStorage.setItem("likedPosts", JSON.stringify(likedPosts))
                })
            }
        }}>
            <Heart fill={liked ? "var(--mantine-color-red-6)" : "#fff"} />
        </ActionIcon>
        <Text lh={1} c={"dimmed"} fz="xs">{!likes ? "Like" : likes}</Text>
    </div>
}

const Share = () => {
    const [shareModal, setShareModal] = useState(false)
    return <div className='flex fdc aic'>
        <Modal
            opened={shareModal}
            onClose={() => setShareModal(false)}
            title={<Text fw={600}>Share this article</Text>}
            styles={{ root: { zIndex: 9999 }, inner: { zIndex: 999999 }, overlay: { zIndex: 999999 } }}
            centered
        >
            <Box className='flex' style={{ gap: 10 }}>
                {typeof window !== "undefined"
                    ? <CopyBox value={window.location.href} />
                    : null
                }

                {/* <Box className='flex aic' style={{ gap: 10 }} mt={10}>
                    <ActionIcon variant={"filled"} color="blue" radius={100} size="lg" onClick={() => window.open(`http://twitter.com/share?text=Read this awesome article from AgencyAccess&url=${encodeURIComponent(window.location.href)}`)}>
                        <BrandTwitter />
                    </ActionIcon>
                </Box> */}
            </Box>
            <Button variant={"default"} w="100%" mt={10} onClick={() => setShareModal(false)}>Close</Button>
        </Modal>
        <ActionIcon onClick={() => setShareModal(true)} radius={100} size="lg">
            <ShareIcon />
        </ActionIcon>
        <Text lh={1} c={"dimmed"} fz="xs">Share</Text>
    </div>
}

export default function BlogLayout({ children }: PropsWithChildren) {
    const smallerDesktop = useMediaQuery('(max-width: 620px)')
    return (
        <div className='flex jcc' style={{ width: "100%", padding: `${smallerDesktop ? 20 : 40}px 20px`, paddingBottom: 50, gap: smallerDesktop ? 15 : 30, position: "relative", flexDirection: smallerDesktop ? "column-reverse" : "row" }}>
            <div style={{ width: "100%", maxWidth: 750 }}>
                {children}
            </div>
            <div className={`flex ${smallerDesktop ? "" : "fdc"}`} style={{ gap: 15 }}>
                <Like />
                <Share />
            </div>
        </div>
    )
}
